import React from 'react';

export const getColumns = () => {
  return [
    {
      'Header': 'FACTURAR A',
      'accessor': 'invoiceTo',
    },
    {
      'Header': 'ASIGNADO A',
      'accessor': 'assignedTo',
    },
    {
      'Header': 'PEDIDO',
      'accessor': 'orderNo',
    },
    {
      'Header': 'FECHA PDS',
      'accessor': 'pdsDate',
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            {row.original.pdsDate !== 'Fecha inválida' ? row.original.pdsDate : ''}</div>
        );
      },
    },
    {
      'Header': 'TIPO VEH.',
      'accessor': 'vehType',
    },
    {
      'Header': 'CHASIS',
      'accessor': 'chassis',
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
    },
    {
      'Header': 'SFX',
      'accessor': 'sfx',
    },
    {
      'Header': 'KATASHIKI',
      'accessor': 'katashiki',
    },
    {
      'Header': 'UBICACIÓN',
      'accessor': 'location',
    },
  ];
};
